import React, { useState, useEffect } from 'react';

import { 
    useCompanyInfo, useBillingInfo, 
    useBusinessInfo,
} from "./hooks";
import { DashboardLayout, Button, Spinner, AlertMessage } from "components";

import { func_validation } from "functions";

import ic_small_add from "assets/images/ic_small_add.svg";
import ic_small_save from "assets/images/ic_small_save.svg";

import "assets/scss/distributorPortal/modules/clientRegistration/clientRegistration_update.scss";



export default function UpdateClient(props) {
    // Props  
    const { 
        isEditing,

        addClient_requesting,
        updateClient_requesting,

        addClient_errorMsg,
        updateClient_errorMsg,

        isClientRecordUpdatedSuccessfully
    } = props;
    
    // States

    const [isFormSubmissionAttempted, setFormSubmissionStatus] = useState(false);

    const [alertMsg, setAlertMsg] = useState("");
    const [isAlertMsgVisible, setIsAlertMsgVisible] = useState(false);

    // Page Header
    let pageHeaderTitle = isEditing? "Edit Client": "Add Client";
    
    // Error Messages
    function handleError(errorMsg) {
        if (func_validation.isStringTrimNotEmpty(errorMsg) && 
            isFormSubmissionAttempted) {

            setAlertMsg(errorMsg);
            setIsAlertMsgVisible(true);
        }
    }
    useEffect(() => {
        handleError(addClient_errorMsg);
    }, [addClient_errorMsg]);
    useEffect(() => {
        handleError(updateClient_errorMsg);
    }, [updateClient_errorMsg]);


    /* Hooks */

    // Company
    const {
        companyName,
        companyEmail,
        name,
        mobileNo,
        
        display: companyInputDisplay
    } = useCompanyInfo({
        ...props, 
        isFormSubmissionAttempted: isFormSubmissionAttempted,
    });

    // Billing
    const { 
        personInCharge,
        brand,
        type,
        
        display: billingInputDisplay
    } = useBillingInfo({
        ...props, 
        isFormSubmissionAttempted: isFormSubmissionAttempted, 
    });

    // Business
    const { 
        billingStreet,
        billingCity,
        billingState,
        billingPostcode,
        billingCountry,
        
        display: businessInputDisplay
    } = useBusinessInfo({
        ...props, 
        isFormSubmissionAttempted: isFormSubmissionAttempted, 
    });

    // Submits
    let submitIcon = isEditing? ic_small_save: ic_small_add;
    let submitText = isEditing? "Save": "Add";
    let submitAltText = isEditing? "Save Icon": "Add Icon";
    function handleSubmission() {

        let isEveryInputValid = (
            func_validation.isStringTrimNotEmpty(companyName) &&
            func_validation.isStringTrimNotEmpty(companyEmail) &&
            func_validation.isStringTrimNotEmpty(name) &&
            func_validation.isStringTrimNotEmpty(mobileNo) &&

            func_validation.isStringTrimNotEmpty(personInCharge) &&
            func_validation.isStringTrimNotEmpty(brand) &&
            func_validation.isStringTrimNotEmpty(type) &&

            func_validation.isStringTrimNotEmpty(billingStreet) &&
            func_validation.isStringTrimNotEmpty(billingCity) &&
            func_validation.isStringTrimNotEmpty(billingState) &&
            func_validation.isStringTrimNotEmpty(billingPostcode) &&
            func_validation.isStringTrimNotEmpty(billingCountry)
        );

        if (isEveryInputValid) {
            let companyDetails = {
                companyName: companyName,
                companyEmail: companyEmail,
                name: name,
                mobileNo: mobileNo,

                personInCharge: personInCharge,
                brand: brand,
                type: type,

                billingStreet: billingStreet,
                billingCity: billingCity,
                billingState: billingState,
                billingPostcode: billingPostcode,
                billingCountry: billingCountry,
            };

            if (isEditing && props.updateClient) 
                props.updateClient(companyDetails);
            else if (props.addClient) 
                props.addClient(companyDetails);
        }
        setFormSubmissionStatus(true);
    }
    function handleSuccessfulSubmission() {
        if (isClientRecordUpdatedSuccessfully &&
            isFormSubmissionAttempted &&
            props.updateParentState_visiblity)
            props.updateParentState_visiblity(false);
    }
    useEffect(() => {
        handleSuccessfulSubmission();
    }, [isClientRecordUpdatedSuccessfully]);

    let isLoading = addClient_requesting || updateClient_requesting;

    return (
        <DashboardLayout
            headerTitle={pageHeaderTitle}
            isHeaderCloseIconVisible

            bodyClassName={"distributorPortal-clientRegistration"}
            body={(
                <React.Fragment>
                    <div className="distributorPortal-clientRegistration-subHeader d-flex justify-content-end">
                        {/* Action */}
                        <Button
                            className={"distributorPortal-clientRegistration-subHeader-action"}
                            handleOnClick={handleSubmission}
                            isDecoration_transparentDarkGreyBorder
                        >
                            <div className={"d-flex flex-column align-items-center justify-content-center"}>
                                {isLoading? (
                                    <Spinner size={0} isLeftMarginOptional />
                                ):(
                                    <img
                                        src={submitIcon}
                                        alt={submitAltText}
                                        className={"distributorPortal-clientRegistration-subHeaderAction-icon"}
                                    />
                                )}
                                <div className={"distributorPortal-clientRegistration-subHeaderAction-text"}>
                                    {submitText}
                                </div>
                            </div>
                        </Button>
                    </div>

                    <div className="distributorPortal-clientRegistration-inputWrapper">
                        {/* Alert Error Messages */}
                        <AlertMessage
                            message={alertMsg}
                            isVisible={isAlertMsgVisible}
                            toggleVisibility={() => { setIsAlertMsgVisible(!isAlertMsgVisible); }}
                        />
                        
                        {/* Company Info */}
                        {companyInputDisplay}
            
                        {/* Billing Info */}
                        {billingInputDisplay}
            
                        {/* Business Info  */}
                        {businessInputDisplay}
                    </div>
                </React.Fragment>
            )}

            updateParentState_visiblity={props.updateParentState_visiblity}
        />
    );
}